var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 307,
    viewBox: "0 0 444 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4506_57819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.06 227.45H150.95V250.5H119.19V227.45H71.71V203.83L121.23 131.43H150.96V203.42H164.07V227.45H164.06ZM119.19 203.42V189.57C119.19 186.96 119.28 183.45 119.47 179.02C119.66 174.6 119.81 172.27 119.92 172.06H119.02C117.17 176.24 115.08 180.15 112.75 183.79L99.56 203.42H119.19Z",
    fill: "#F8371D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45 191.13C258.45 212.2 254.92 227.63 247.86 237.43C240.8 247.23 230 252.13 215.45 252.13C200.9 252.13 190.5 247.01 183.28 236.78C176.06 226.55 172.45 211.33 172.45 191.13C172.45 170.93 175.98 154.43 183.04 144.54C190.1 134.66 200.9 129.72 215.45 129.72C230 129.72 240.33 134.86 247.58 145.15C254.83 155.44 258.45 170.76 258.45 191.12V191.13ZM204.45 191.13C204.45 204.6 205.29 213.85 206.98 218.9C208.66 223.95 211.49 226.47 215.45 226.47C219.41 226.47 222.3 223.86 223.96 218.65C225.62 213.44 226.44 204.26 226.44 191.12C226.44 177.98 225.6 168.68 223.92 163.39C222.24 158.1 219.41 155.45 215.45 155.45C211.49 155.45 208.66 158 206.98 163.11C205.3 168.21 204.45 177.55 204.45 191.13Z",
    fill: "#F8371D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.52 227.45H346.41V250.5H314.65V227.45H267.17V203.83L316.69 131.43H346.42V203.42H359.53V227.45H359.52ZM314.65 203.42V189.57C314.65 186.96 314.74 183.45 314.94 179.02C315.13 174.6 315.28 172.27 315.39 172.06H314.49C312.64 176.24 310.55 180.15 308.22 183.79L295.03 203.42H314.66H314.65Z",
    fill: "#F8371D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.99 157.85H72.12",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6802 157.85H93.9502",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 144.3H101.44",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17008 144.3H1.08008",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 131.43H43.88",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.54 131.43H111.62",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24 265.34H415.76",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13 265.34H431.58",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53 251.79H442.04",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.39 251.79H364.24",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24 238.92H395.28",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.83 238.92H424.13",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.23 227H157.12V250.05H125.36V227H77.8801V203.38L127.4 130.98H157.13V202.97H170.24V227H170.23ZM125.36 202.97V189.12C125.36 186.51 125.45 183 125.64 178.57C125.83 174.15 125.98 171.82 126.09 171.61H125.19C123.34 175.79 121.25 179.7 118.92 183.34L105.73 202.97H125.36Z",
    stroke: "#1D1B20",
    strokeWidth: 3.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62 190.67C264.62 211.74 261.09 227.17 254.03 236.97C246.97 246.77 236.17 251.67 221.62 251.67C207.07 251.67 196.67 246.55 189.45 236.32C182.23 226.09 178.62 210.87 178.62 190.67C178.62 170.47 182.15 153.97 189.21 144.08C196.27 134.2 207.07 129.26 221.62 129.26C236.17 129.26 246.5 134.4 253.75 144.69C261 154.98 264.62 170.3 264.62 190.66V190.67ZM210.62 190.67C210.62 204.14 211.46 213.39 213.15 218.44C214.83 223.49 217.66 226.01 221.62 226.01C225.58 226.01 228.47 223.4 230.13 218.19C231.79 212.98 232.61 203.8 232.61 190.66C232.61 177.52 231.77 168.22 230.09 162.93C228.41 157.64 225.58 154.99 221.62 154.99C217.66 154.99 214.83 157.54 213.15 162.64C211.47 167.74 210.62 177.08 210.62 190.66V190.67Z",
    stroke: "#1D1B20",
    strokeWidth: 3.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.69 227H352.58V250.05H320.82V227H273.34V203.38L322.86 130.98H352.59V202.97H365.7V227H365.69ZM320.82 202.97V189.12C320.82 186.51 320.91 183 321.11 178.57C321.3 174.15 321.45 171.82 321.56 171.61H320.66C318.81 175.79 316.72 179.7 314.39 183.34L301.2 202.97H320.83H320.82Z",
    stroke: "#1D1B20",
    strokeWidth: 3.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72 154.92V143.88",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.02 158.11L371.21 150.3",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83 165.81H364.79",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.02 173.52L371.21 181.32",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72 176.71V187.75",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.43 173.52L402.24 181.32",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.62 165.81H408.66",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.43 158.11L402.24 150.3",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5002 209.88V201.9",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.93 212.19L29.28 206.55",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6201 217.76H24.6401",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.93 223.33L29.28 228.97",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5002 225.64V233.62",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0701 223.33L51.7101 228.97",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3701 217.76H56.3501",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0701 212.19L51.7101 206.55",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42 45.07V37.09",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85 47.38L245.21 41.73",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54 52.95H240.56",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85 58.52L245.21 64.16",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42 60.8199V68.7999",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.99 58.52L267.63 64.16",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.29 52.95H272.27",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.99 47.38L267.63 41.73",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44 112.01V77.49H280.94V154.21",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67 52.95V96.18H336.7V115.85",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73 116.3C105.73 118.67 103.81 120.58 101.45 120.58C99.0902 120.58 97.1702 118.66 97.1702 116.3C97.1702 113.94 99.0902 112.02 101.45 112.02C103.81 112.02 105.73 113.94 105.73 116.3Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67 52.94C220.034 52.94 221.95 51.0238 221.95 48.66C221.95 46.2962 220.034 44.38 217.67 44.38C215.306 44.38 213.39 46.2962 213.39 48.66C213.39 51.0238 215.306 52.94 217.67 52.94Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.98 120.58C340.98 122.95 339.06 124.86 336.7 124.86C334.34 124.86 332.42 122.94 332.42 120.58C332.42 118.22 334.34 116.3 336.7 116.3C339.06 116.3 340.98 118.22 340.98 120.58Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22 159.2C285.22 161.57 283.3 163.48 280.94 163.48C278.58 163.48 276.66 161.56 276.66 159.2C276.66 156.84 278.58 154.92 280.94 154.92C283.3 154.92 285.22 156.84 285.22 159.2Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5301 244.98L63.4001 255.11",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4001 244.98L73.5301 255.11",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6 97.8201L68.46 107.95",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.46 97.8201L78.6 107.95",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3 212.69L397.17 222.83",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17 212.69L407.3 222.83",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7 39.98C116.47 39.98 113.51 41.14 111.21 43.07C108.86 36.01 102.22 30.91 94.3701 30.91C85.5801 30.91 78.3101 37.3 76.8801 45.68C75.9501 45.41 74.9801 45.26 73.9701 45.26C68.1301 45.26 63.3901 50 63.3901 55.84C63.3901 61.21 67.4001 65.64 72.5901 66.32V66.42H119.7C127 66.42 132.92 60.5 132.92 53.2C132.92 45.9 127 39.98 119.7 39.98Z",
    stroke: "#1D1B20",
    strokeWidth: 2.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84 107.23C367.19 107.23 369.34 108.07 371.01 109.47C372.71 104.34 377.54 100.64 383.25 100.64C389.63 100.64 394.92 105.28 395.95 111.37C396.62 111.18 397.33 111.07 398.07 111.07C402.31 111.07 405.76 114.51 405.76 118.76C405.76 122.66 402.85 125.88 399.07 126.37V126.44H364.85C359.55 126.44 355.24 122.14 355.24 116.83C355.24 111.52 359.54 107.22 364.85 107.22L364.84 107.23Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.02 288.93C410.05 288.93 408.25 289.64 406.85 290.81C405.42 286.51 401.37 283.4 396.59 283.4C391.24 283.4 386.8 287.29 385.94 292.4C385.38 292.24 384.78 292.15 384.17 292.15C380.61 292.15 377.72 295.04 377.72 298.6C377.72 301.87 380.16 304.57 383.33 304.98V305.04H412.03C416.48 305.04 420.09 301.43 420.09 296.98C420.09 292.53 416.48 288.92 412.03 288.92L412.02 288.93Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4901 271.93C24.8401 271.93 26.9901 272.77 28.6601 274.17C30.3601 269.04 35.1901 265.34 40.9001 265.34C47.2801 265.34 52.5701 269.98 53.6001 276.07C54.2701 275.88 54.9801 275.77 55.7201 275.77C59.9601 275.77 63.4101 279.21 63.4101 283.46C63.4101 287.36 60.5001 290.58 56.7201 291.07V291.14H22.4901C17.1901 291.14 12.8801 286.84 12.8801 281.53C12.8801 276.22 17.1801 271.92 22.4901 271.92V271.93Z",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93 33.63C132.93 33.63 193.37 -15.64 275.49 7.06001C361.75 30.91 379.02 92.42 379.02 92.42",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6702 176.86C18.2402 180.49 6.46017 230.22 32.8202 249.96",
    stroke: "#1D1B20",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75 120.58V95.23",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63 120.58V107.95",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.91 126.44V107.91",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.95 124.86V117.18",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79 124.86V112.01",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63 120.58V107.91",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.63 124.11V118.44",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51 124.11V110.3",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51 124.11V114.24",
    stroke: "#1D1B20",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4506_57819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443.12,
    height: 306.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.371dcefdd3c867a170aab225b6a5bac1.svg";
export { ForwardRef as ReactComponent };